/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FacetNavigationPrice } from '@/components/content/HelloRetailFacetNavigation/parts/Price';
import { facetNavigationAccordionSX } from '@/components/content/FacetNavigation/styles/accordion';
import { facetNavigationAccordionSummarySX } from '@/components/content/FacetNavigation/styles/accordionSummary';
import { useLocalization } from '@/data/Localization';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Breakpoint,
    Typography,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, SyntheticEvent, useCallback, useState } from 'react';

const mobileBreakpoint: Breakpoint = 'md';

export const FacetNavigationPriceChange: FC = () => {
    const productFilterNLS = useLocalization('ProductFilter');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint));
    const [activeFacetId, setActiveFacetId] = useState<string>(() => '');

    const handleAccordionChange = useCallback(
        (facetValue: string) => (_event: SyntheticEvent<Element, Event>, isExpanded: boolean) => {
            isMobile && setActiveFacetId(isExpanded ? facetValue : '');
        },
        [isMobile]
    );
    return (
        <Accordion
            data-testid={`productFilter-facet-price`}
            id={`productFilter-facet-price`}
            defaultExpanded={!isMobile}
            expanded={!isMobile || activeFacetId === 'price'}
            onChange={handleAccordionChange('price')}
            square={true}
            sx={facetNavigationAccordionSX}
        >
            <AccordionSummary
                sx={facetNavigationAccordionSummarySX}
                expandIcon={isMobile ? <ExpandMoreIcon /> : null}
            >
                <Typography variant="body2">
                    {productFilterNLS.Labels.price.t()}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <FacetNavigationPrice />
            </AccordionDetails>
        </Accordion>
    )
};
